import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import GoBackButton from "../../layout/GoBackButton";
import { downloadSparepartImportDocument, getSparepartImport } from "../../../actions/sparepartImports";
import MoneyFormat from "../../layout/MoneyFormat";
import Moment from "react-moment";
import { Download } from "react-feather";
import ButtonLoader from "../../layout/ButtonLoader";
import ColorPicker from "../../layout/ColorPicker";
import moment from 'moment';
import { Badge } from 'react-bootstrap';

const SparepartImportPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { sparepartImport } = useSelector(state => state.sparepartImport);
    const [isLoading, setIsLoading] = useState(false);
    const [textColor, setTextColor] = useState('#000000');

    useEffect(() => {
        dispatch(getSparepartImport(id));
    }, [dispatch, id]);

    const onDownload = async (id) => {
        setIsLoading(true);
        try {
            const data = await dispatch(downloadSparepartImportDocument(id, textColor));
            if (data?.url) {
                window.open(data.url, '_blank');
            }
        } catch (error) {
            console.error('Download failed:', error);
        }
        setIsLoading(false);
    };

    // Function to determine item label based on update/deletion status
    const getItemLabel = (importRecord, item) => {
        if (importRecord?.deleted_at) {
            return "O'chirilgan"; // Import is deleted
        } else if (item?.deleted_at) {
            return "O'chirilgan"; // Import is active but item is deleted
        } else if (isItemUpdated(item)) {
            return "O'zgartirilgan"; // Item has been updated
        }
        return null; // No label needed
    };

    // Function to check if an item has been updated
    const isItemUpdated = (item) => {
        if (!item?.created_at || !item?.updated_at) return false;
        return moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') !== moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss');
    };

    // Function to check if the import has been updated
    const isImportUpdated = (importRecord) => {
        if (!importRecord?.created_at || !importRecord?.updated_at) return false;
        return moment(importRecord.created_at).format('YYYY-MM-DD HH:mm:ss') !== moment(importRecord.updated_at).format('YYYY-MM-DD HH:mm:ss');
    };

    // Function to get item styling based on deletion/update status
    const getItemStyle = (importRecord, item) => {
        if (importRecord?.deleted_at || item?.deleted_at) {
            return {
                backgroundColor: '#ffeeee',
                border: '1px solid #dc3545',
                borderRadius: '4px',
                padding: '8px',
                margin: '4px 0'
            };
        } else if (isItemUpdated(item)) {
            return {
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '4px',
                padding: '8px',
                margin: '4px 0'
            };
        }
        return {
            padding: '4px 0'
        };
    };

    // Function to get text styling for item content
    const getItemTextStyle = (importRecord, item) => {
        // If import is active but item is deleted, add strikethrough
        if (!importRecord?.deleted_at && item?.deleted_at) {
            return {
                textDecoration: 'line-through',
                opacity: 0.7
            };
        }
        return {};
    };

    const formatNumber = (value) => {
        if (value || value === 0) {
            return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return '0.00';
    };

    const formatQuantity = (value) => {
        if (value || value === 0) {
            return Number(value).toFixed(5).replace(/\.?0+$/, '').replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
        }
        return '0';
    };

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">
                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3">
                                <strong>Ehtiyot qism import</strong> ma'lumotlari
                                {sparepartImport?.deleted_at && (
                                    <Badge bg="danger" className="ms-2">O'chirilgan</Badge>
                                )}
                                {isImportUpdated(sparepartImport) && (
                                    <Badge bg="warning" className="ms-2">O'zgartirilgan</Badge>
                                )}
                            </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <div className="d-flex align-items-center justify-content-end mb-2">
                                    <span className="me-2 small text-muted">Text Color:</span>
                                    <ColorPicker 
                                        selectedColor={textColor} 
                                        onColorChange={setTextColor}
                                        disabled={isLoading}
                                    />
                                </div>
                                <button 
                                    onClick={() => onDownload(id)}
                                    className="btn text-center btn-primary me-2"
                                >
                                    {isLoading && <ButtonLoader />}
                                    Hujjat yuklash
                                    <Download className="ms-2" />
                                </button>
                                <GoBackButton />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-lg-12">
                            <div className="card">
                                {/* Supplier Information */}
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">
                                            Ta'minotchi ma'lumotlari
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Nomi:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.supplier ? (
                                                    <Link to={`/suppliers/${sparepartImport.supplier.id}`}>
                                                        {sparepartImport.supplier.name}
                                                    </Link>
                                                ) : '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Javobgar shaxs:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.supplier?.contractor || '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Telefon:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.supplier?.phone || '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Bank hisobi:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.supplier?.bank_account || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Warehouse Information */}
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">
                                            Ombor ma'lumotlari
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Firma:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.warehouse?.firm ? (
                                                    <Link to={`/firms/${sparepartImport.warehouse.firm.id}`}>
                                                        {sparepartImport.warehouse.firm.name}
                                                    </Link>
                                                ) : '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Ombor:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.warehouse?.name || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Importer Information */}
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">
                                            Import qiluvchi
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Ismi:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.importer ? (
                                                    <Link to={`/users/${sparepartImport.importer.id}`}>
                                                        {sparepartImport.importer.name}
                                                    </Link>
                                                ) : '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Email:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.importer?.email || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Import Items */}
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">
                                            Import qilingan ehtiyot qismlar
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {sparepartImport?.items?.map((item, index) => {
                                            const itemLabel = getItemLabel(sparepartImport, item);
                                            const itemStyle = getItemStyle(sparepartImport, item);
                                            const itemTextStyle = getItemTextStyle(sparepartImport, item);
                                            
                                            return (
                                                <div key={index} className="d-flex align-items-center" style={itemStyle}>
                                                    <div className="card-title m-2">
                                                        <Link to={`/spare-parts/${item.spare_part_id}`}>
                                                            {item.spare_part?.name}
                                                        </Link>:
                                                    </div>
                                                    <div className="text-muted m-0" style={itemTextStyle}>
                                                        {formatQuantity(item.quantity)} {item.spare_part?.unit?.name} x {formatNumber(item.price)} so'm = 
                                                        <MoneyFormat value={item.total_amount}/> so'm
                                                        {itemLabel && (
                                                            <span className={`badge ms-2 ${
                                                                sparepartImport?.deleted_at || item?.deleted_at ? 'bg-danger' : 'bg-warning'
                                                            }`}>
                                                                {itemLabel}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div className="d-flex align-items-center mt-3">
                                            <div className="card-title m-2">Jami summa:</div>
                                            <div className="text-muted m-0">
                                                <MoneyFormat value={sparepartImport?.total_amount}/> so'm
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* General Information */}
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h4 className="card-title text-dark text-decoration-underline mb-0">
                                            Umumiy ma'lumotlar
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Import raqami:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.reference_number || sparepartImport?.id}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Import sanasi:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.date}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Yaratilgan:</div>
                                            <div className="text-muted m-0">
                                                <Moment date={sparepartImport?.created_at} format={'DD.MM.YYYY HH:mm'}/>
                                            </div>
                                        </div>
                                        {sparepartImport?.updated_at && isImportUpdated(sparepartImport) && (
                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">Oxirgi o'zgartirish:</div>
                                                <div className="text-warning m-0">
                                                    <Moment date={sparepartImport.updated_at} format={'DD.MM.YYYY HH:mm'}/>
                                                </div>
                                            </div>
                                        )}
                                        {sparepartImport?.deleted_at && (
                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">O'chirilgan:</div>
                                                <div className="text-danger m-0">
                                                    <Moment date={sparepartImport.deleted_at} format={'DD.MM.YYYY HH:mm'}/>
                                                </div>
                                            </div>
                                        )}
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Izoh:</div>
                                            <div className="text-muted m-0">
                                                {sparepartImport?.description || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default SparepartImportPage; 